var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"text-center",attrs:{"aria-label":"Page Navigation"}},[_c('ul',{staticClass:"pagination"},_vm._l((_vm.links),function(link,linkIdx){return _c('li',{class:{
				'active' : link.active,
				'disabled': link.url == null
			}},[_c('a',{attrs:{"href":"#","aria-label":link.label},on:{"click":function($event){return _vm.$emit('page-nav', linkIdx)}}},[_c('span',{attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(link.label)}})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }